import { Fragment, useEffect, useState } from 'react';
import styled from 'styled-components';

type LocationRadiusProps = {
  cx: string;
  cy: string;

  r1: string;
  r2: string;
  r3: string;

  fill1: string;
  fill2: string;
  fill3: string;

  opacity1: string;
  opacity2: string;
  opacity3: string;

  timeout: number;
};

function LocationRadius({
  cx,
  cy,
  r1,
  r2,
  r3,
  fill1,
  fill2,
  fill3,
  opacity1,
  opacity2,
  opacity3,
  timeout,
}: LocationRadiusProps) {
  const [rings, setRings] = useState(1);
  const [secondRingVisible, setSecondRingVisible] = useState(false);
  const [thirdRingVisible, setThirdRingVisible] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      if (rings === 5) {
        setRings(1);
        setSecondRingVisible(false);
        setThirdRingVisible(false);
        return;
      }

      const ringsCount = rings + 1;

      if (ringsCount === 2) setSecondRingVisible(true);
      if (ringsCount === 3) setThirdRingVisible(true);

      setRings(ringsCount);
    }, timeout);

    return () => clearInterval(interval);
  }, [rings]);

  return (
    <Fragment>
      <StyledCircle
        cx={cx}
        cy={cy}
        r={r1}
        fill={fill1}
        $fillOpacity={opacity1}
        $visible
      />

      <StyledCircle
        cx={cx}
        cy={cy}
        r={r2}
        fill={fill2}
        $fillOpacity={opacity2}
        $visible={secondRingVisible}
      />

      <StyledCircle
        cx={cx}
        cy={cy}
        r={r3}
        fill={fill3}
        $fillOpacity={opacity3}
        $visible={thirdRingVisible}
      />
    </Fragment>
  );
}

const StyledCircle = styled.circle<{ $visible: boolean; $fillOpacity: string }>`
  transition: 0.5s ease;

  fill-opacity: ${({ $fillOpacity, $visible }) => {
    if ($visible) return $fillOpacity;

    return 0;
  }};
`;

export default LocationRadius;
